import { registerComponent, getStoreData } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "product-availability-pickup-store",
  class ProductAvailabilityPickupStore extends WYATTElement {
    constructor() {
      super();

      this.dataset.loading = "true";
      this.available = this.dataset.available === "true";
      this.savedStoreId = localStorage.getItem("pickup_store_id");
      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId;
      this.checkAllVariants = this.dataset.checkAllVariants === "true";

      this.contentContainer = this.querySelector(
        "[data-product-availability='content']",
      );
      this.storeNameContainer = this.querySelector(
        "[data-product-availability='store-name']",
      );
      this.inventoryContainer = this.querySelector(
        "[data-product-availability='inventory']",
      );
      this.drawerButton = this.querySelector(".product-availability__button");

      if (this.savedStoreId) {
        this.savedStore = getStoreData(this.savedStoreId);
        this.renderTemplateWithStore();
      } else {
        this.renderTemplateWithoutStore();
      }

      if (this.productId !== "") {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      this.drawerButton.removeEventListener(
        "click",
        this.handleDrawerButtonClick.bind(this),
      );
    }

    bindEvents() {
      this.drawerButton.addEventListener(
        "click",
        this.handleDrawerButtonClick.bind(this),
      );

      this.subscribe(
        window.WYATT.PubSub.events.updatePickupStore,
        this.handleUpdatePickupStore.bind(this),
      );
    }

    async renderTemplateWithStore() {
      await this.renderInventory();
      this.storeNameContainer.textContent = this.savedStore.name;
      this.drawerButton.textContent = "Change";
      this.dataset.loading = "false";
    }

    renderTemplateWithoutStore() {
      this.inventoryContainer.innerHTML = "Pick up in store";
      this.storeNameContainer.textContent = "";
      this.drawerButton.textContent = "Select store";
      this.removeAttribute("data-available");
      this.dataset.loading = "false";
    }

    handleDrawerButtonClick() {
      this.publish(window.WYATT.PubSub.events.openStorePickupForm, {
        productId: this.productId,
        variantId: this.variantId,
        checkAllVariants: this.checkAllVariants,
      });
    }

    handleUpdatePickupStore(event) {
      this.savedStore = getStoreData(event.detail.storeID);
      this.renderTemplateWithStore();
    }

    async renderInventory() {
      let availabilities;
      let quantityAvailable = 0;

      try {
        availabilities =
          await window.WYATT.storeAvailability.gettingAvailability(
            this.productId,
          );
      } catch (error) {
        this.remove();
        return;
      }

      if (this.checkAllVariants) {
        Object.values(availabilities).forEach((value) => {
          const savedStoreAvailability = value.find(
            (availability) =>
              availability.id.toString() === this.savedStore.location_id,
          );
          quantityAvailable += savedStoreAvailability?.quantityAvailable || 0;
        });
      } else {
        const savedStoreAvailability = availabilities[this.variantId].find(
          (availability) =>
            availability.id.toString() === this.savedStore.location_id,
        );
        quantityAvailable = savedStoreAvailability?.quantityAvailable;
      }

      if (quantityAvailable === 1) {
        this.inventoryContainer.innerHTML = this.checkAllVariants
          ? "In stock at"
          : `${quantityAvailable} item in stock at`;
        this.setAttribute("data-available", "true");
      } else if (quantityAvailable > 0) {
        this.inventoryContainer.innerHTML = this.checkAllVariants
          ? "In stock at"
          : `${quantityAvailable} in stock at`;
        this.setAttribute("data-available", "true");
      } else {
        this.inventoryContainer.innerHTML = `Out of stock at`;
        this.setAttribute("data-available", "false");
      }
    }
  },
);
